import React, { useLayoutEffect, useMemo } from 'react';
import dayjs from 'dayjs';
import {
  PageContainer,
  SectionContainer,
  ContentContainer,
  Content,
  Title,
  Text,
  ButtonStyled,
  PictureContainer,
  SectionDivider,
  SectionTitle,
} from './Hiking.styles';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HIKE_TRIPS, HikeTrip } from './hikesData';

export const Hiking = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const upcomingTrips = useMemo(
    () =>
      HIKE_TRIPS.filter((trip) => trip.section === 'upcoming').sort((a, b) =>
        dayjs(a.sortDate).diff(dayjs(b.sortDate)),
      ),
    [],
  );

  const archivedTrips = useMemo(
    () =>
      HIKE_TRIPS.filter((trip) => trip.section === 'archived').sort((a, b) =>
        dayjs(b.sortDate).diff(dayjs(a.sortDate)),
      ),
    [],
  );

  const renderTripTile = (trip: HikeTrip, isPast: boolean) => {
    const isFeatured = !isPast && upcomingTrips.length === 1;

    return (
      <ContentContainer key={trip.id} isPast={isPast} isFeatured={isFeatured}>
        <Content isFeatured={isFeatured}>
          <Title isFeatured={isFeatured}>{t(trip.titleKey)}</Title>
          <Text>{t(trip.destinationKey)}</Text>
          <Text>{t(trip.dateKey)}</Text>
          {trip.extraDateKeys?.map((dateKey) => (
            <Text key={dateKey}>{t(dateKey)}</Text>
          ))}
          {trip.seatsKey && <Text>{t(trip.seatsKey)}</Text>}
          <ButtonStyled type="button" onClick={() => navigate(trip.route)}>
            {t(trip.buttonKey)}
          </ButtonStyled>
        </Content>
        <PictureContainer background={trip.background} isFeatured={isFeatured} />
      </ContentContainer>
    );
  };

  return (
    <PageContainer>
      <div id="wyjazdy-2026">
        <SectionTitle large>{t('nav.trips2026')}</SectionTitle>
        <SectionContainer>
          {upcomingTrips.map((trip) => renderTripTile(trip, false))}
        </SectionContainer>
      </div>

      <SectionDivider />

      <div id="archiwalne">
        <SectionTitle>{t('hiking.section-archived-title')}</SectionTitle>
        <SectionContainer>
          {archivedTrips.map((trip) => renderTripTile(trip, true))}
        </SectionContainer>
      </div>

      <SectionDivider />
    </PageContainer>
  );
};
